import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const SEMI_ADMIN_UIDS = [
  'e1baf18f-5ba3-4e78-a12b-facef9c8a26e',
  'ac476a89-bd2a-47f0-a0d1-00a5fe93dbc5',
];

export function useAuth() {
  const [user, setUser] = useState(null);
  const [userNickname, setUserNickname] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isSemiAdmin, setIsSemiAdmin] = useState(false);

  // Auth state subscription
  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_, session) => {
      setUser(session?.user ?? null);
    });
    return () => subscription.unsubscribe();
  }, []);

  // Fetch nickname
  useEffect(() => {
    if (!user) { setUserNickname(null); return; }
    supabase.from('profiles').select('nickname').eq('user_id', user.id).single()
      .then(({ data }) => setUserNickname(data?.nickname ?? null));
  }, [user]);

  // Admin check
  useEffect(() => {
    if (!user) { setIsAdmin(false); setIsSemiAdmin(false); return; }
    supabase.from('admins').select('user_id').eq('user_id', user.id).maybeSingle()
      .then(({ data }) => setIsAdmin(!!data));
    setIsSemiAdmin(SEMI_ADMIN_UIDS.includes(user.id));
  }, [user]);

  return { user, userNickname, setUserNickname, isAdmin, isSemiAdmin };
}
